/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateQuestionPromptsControllerFindAllQueryResponse, TemplateQuestionPromptsControllerFindAllQueryParams, TemplateQuestionPromptsControllerFindAll401, TemplateQuestionPromptsControllerFindAll403 } from "../../models/checklistsController/TemplateQuestionPromptsControllerFindAll";

function getTemplateQuestionPromptsControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/checklist-template-question-prompts` as const }  
  return res
}

/**
 * @summary Get all checklist template question prompts
 * {@link /api/v1/checklist-template-question-prompts}
 */
export async function templateQuestionPromptsControllerFindAll(params?: TemplateQuestionPromptsControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TemplateQuestionPromptsControllerFindAllQueryResponse, ResponseErrorConfig<TemplateQuestionPromptsControllerFindAll401 | TemplateQuestionPromptsControllerFindAll403>, unknown>({ method : "GET", url : getTemplateQuestionPromptsControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}